export default __webpack_public_path__ + "static/media/profilepic.57e3d4a7.jpg";